import React from 'react'
import PropTypes from 'prop-types'
import '../../globals/scss/components/maintenance.scss'

export const MaintenanceMode = ({ appCode, appName }) => {
  return (
    <div className="maintenancePage">
      <div className="maintenancePage__container">
        <h1>
          <span className="maintenancePage__appAcronym">{appCode}</span> Is Down for Maintenance
        </h1>
        <img
          className="illustration"
          src="assets/images/technical-difficulties-recolored.svg"
          alt="Technical Difficulties"
        />
        <p>
          Please excuse the mess. We are currently working on improving the{' '}
          <span className="maintenancePage__appName">{appName}</span>. We hope to have it back up
          shortly. To speak with our Engineering Technical Support team, please call{' '}
          <a href="tel:+1-800-999-5099">(800) 999-5099</a>. For more information, please visit{' '}
          <a href="https://www.strongtie.com">strongtie.com</a>.
        </p>
      </div>
    </div>
  )
}

MaintenanceMode.propTypes = {
  appCode: PropTypes.string.isRequired,
  appName: PropTypes.string.isRequired,
}
